
import store from '@/store';
import dashboardModule from '@dashboard/store/dashboard';

store.registerModule('dashboard', dashboardModule);